import { render, staticRenderFns } from "./FiscalPeriodsCopyForm.vue?vue&type=template&id=bbfa4b4e&"
import script from "./FiscalPeriodsCopyForm.vue?vue&type=script&lang=js&"
export * from "./FiscalPeriodsCopyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports